import React from 'react';
import '../CancellationRefund/styles.css';

const TermsConditions = () => {
  const lastUpdated = new Date().toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1 className="legal-title">Terms &amp; Conditions</h1>
          <p className="legal-updated">Last Updated: {lastUpdated}</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing or using the Douglas &amp; McCartney website, you agree to be bound by these Terms &amp;
              Conditions and all applicable laws. If you do not agree with any part of these terms, please discontinue
              use of this website.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Purpose of This Website</h2>
            <p>
              This website is intended to provide information about Douglas &amp; McCartney, its services, leadership,
              divisions, insights, and related business opportunities. Website content is provided for general
              informational purposes and may be updated, revised, or removed without prior notice.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. No Professional Advice</h2>
            <p>
              Content available on this website, including articles, ebooks, webinars, and marketing materials, is not
              legal, tax, investment, or financial advice. Users should seek independent professional advice before
              making business or investment decisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. User Submissions &amp; Contact Forms</h2>
            <p>
              When you submit a form, request a callback, download material, or register for a webinar, you agree that:
            </p>
            <ul>
              <li>The information provided by you is accurate and complete to the best of your knowledge.</li>
              <li>You are authorised to submit the provided contact information.</li>
              <li>Douglas &amp; McCartney may contact you regarding your request, registration, or inquiry.</li>
              <li>You will not submit misleading, unlawful, abusive, or fraudulent information through the website.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Intellectual Property</h2>
            <p>
              All website content, including text, branding, design elements, graphics, downloadable resources, and
              media (unless otherwise stated), is owned by or licensed to Douglas &amp; McCartney and is protected by
              applicable intellectual property laws.
            </p>
            <ul>
              <li>You may view and use content for personal or internal business reference.</li>
              <li>You may not reproduce, republish, distribute, or commercially exploit content without prior written permission.</li>
              <li>Brand names, logos, and marks may not be used in a misleading or unauthorised manner.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Third-Party Links</h2>
            <p>
              This website may include links to third-party websites, platforms, or tools (including social media,
              external scheduling pages, or payment gateways). Douglas &amp; McCartney is not responsible for the
              content, privacy practices, or availability of third-party websites.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              Douglas &amp; McCartney makes reasonable efforts to maintain the accuracy and availability of the website,
              but does not guarantee uninterrupted access or error-free operation. To the extent permitted by law,
              Douglas &amp; McCartney shall not be liable for direct or indirect losses arising from use of this website,
              reliance on website content, or temporary unavailability of the website.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Modifications to These Terms</h2>
            <p>
              Douglas &amp; McCartney may revise these Terms &amp; Conditions at any time. Continued use of the website
              after updates are published constitutes acceptance of the revised terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact</h2>
            <p>
              For questions related to these Terms &amp; Conditions, please contact Douglas &amp; McCartney at:
            </p>
            <p className="contact-info">
              Email:{' '}
              <a href="mailto:partnerships@douglasmccartney.com" className="legal-inline-link">
                partnerships@douglasmccartney.com
              </a>
              <br />
              Phone: +91 95352 98949
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <button onClick={() => window.close()} className="back-button">Close Window</button>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
